import script from "./admin.vue?vue&type=script&setup=true&lang=js"
export * from "./admin.vue?vue&type=script&setup=true&lang=js"

import "./admin.vue?vue&type=style&index=0&id=3e9fa9ae&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e9fa9ae"]])

export default __exports__